export default "__VITE_ASSET__CWqgEEWR__"